import styled, { css } from 'styled-components';

export const StyledBadges = styled.div<{ isNewBadgesEnabled?: boolean }>`
  display: ${({ isNewBadgesEnabled }) => (isNewBadgesEnabled ? 'grid' : 'flex')};
  grid-template-columns: repeat(3, 1fr);
  flex-wrap: wrap;
  gap: 2.4rem;
  justify-content: ${({ isNewBadgesEnabled }) => (isNewBadgesEnabled ? 'start' : 'center')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
  }

  ${({ isNewBadgesEnabled }) =>
    !isNewBadgesEnabled &&
    css`
      > article {
        margin-bottom: 0;

        > div > p {
          color: ${({ theme }) => theme.colors.text.main};
        }
      }
    `}
`;
